module.exports = __webpack_public_path__ + "img/OBUNoOrder_03.54a10d95.png";